import { render, staticRenderFns } from "./resultsDetails.vue?vue&type=template&id=4cc4e443&scoped=true"
import script from "./resultsDetails.vue?vue&type=script&lang=js"
export * from "./resultsDetails.vue?vue&type=script&lang=js"
import style0 from "./resultsDetails.vue?vue&type=style&index=0&id=4cc4e443&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4e443",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc4e443')) {
      api.createRecord('4cc4e443', component.options)
    } else {
      api.reload('4cc4e443', component.options)
    }
    module.hot.accept("./resultsDetails.vue?vue&type=template&id=4cc4e443&scoped=true", function () {
      api.rerender('4cc4e443', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resultsAnalysis/resultsDetails.vue"
export default component.exports